export interface ScheduleDeviceInfo {
  deviceId: string;
  modelNumber: string;
  serialNumber: string;
  vendor: string;
  type: string;
  isEriTracked: boolean;
}

export function scheduleDeviceInfo(device: {
  id?: string | null;
  modelNumber?: string | null;
  serialNumber?: string | null;
  vendor?: string | null;
  type?: string | null;
  isEriTracked?: boolean | null;
}): ScheduleDeviceInfo | null {
  if (!device.id) return null;
  return {
    deviceId: device.id,
    modelNumber: device.modelNumber || '',
    serialNumber: device.serialNumber || '',
    vendor: device.vendor || '',
    type: device.type || '',
    isEriTracked: device.isEriTracked ?? false
  };
}
